// Central legal/company constants used across Impressum, Privacy pages,
// PDF export and consent banner. Update once, propagates everywhere.
export const COMPANY = {
  name: "OffGROUND",
  street: "Winterthurerstrasse 1",
  postalCode: "81476",
  city: "München",
  country: "Deutschland",
  email: "Info@offground.solutions",
  website: "https://offground.solutions",
  // Fill in when available:
  vatId: "",
  registerCourt: "",
  registerNumber: "",
  responsiblePerson: "",
};

export const GA_MEASUREMENT_ID = "G-MTLVP68FEZ";
